/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateModifierGroupsRequestInnerAllOfModifiersInner
 */
export interface UpdateModifierGroupsRequestInnerAllOfModifiersInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupsRequestInnerAllOfModifiersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupsRequestInnerAllOfModifiersInner
     */
    modifierGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupsRequestInnerAllOfModifiersInner
     */
    modifierId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierGroupsRequestInnerAllOfModifiersInner
     */
    position: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierGroupsRequestInnerAllOfModifiersInner
     */
    priceImpact?: number | null;
}

/**
 * Check if a given object implements the UpdateModifierGroupsRequestInnerAllOfModifiersInner interface.
 */
export function instanceOfUpdateModifierGroupsRequestInnerAllOfModifiersInner(value: object): value is UpdateModifierGroupsRequestInnerAllOfModifiersInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('modifierGroupId' in value) || value['modifierGroupId'] === undefined) return false;
    if (!('modifierId' in value) || value['modifierId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON(json: any): UpdateModifierGroupsRequestInnerAllOfModifiersInner {
    return UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSONTyped(json, false);
}

export function UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateModifierGroupsRequestInnerAllOfModifiersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'modifierGroupId': json['modifierGroupId'],
        'modifierId': json['modifierId'],
        'position': json['position'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
    };
}

export function UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON(json: any): UpdateModifierGroupsRequestInnerAllOfModifiersInner {
    return UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSONTyped(json, false);
}

export function UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSONTyped(value?: UpdateModifierGroupsRequestInnerAllOfModifiersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'modifierGroupId': value['modifierGroupId'],
        'modifierId': value['modifierId'],
        'position': value['position'],
        'priceImpact': value['priceImpact'],
    };
}

